import React, { FC } from "react";
import { PageButton } from "./PageButton";

interface PageButtonsProps {
    readonly current: number;
    readonly min: number;
    readonly max: number;
    onPageSelected(page: number): void;
}

export const PageButtons: FC<PageButtonsProps> = props => {
    const { current, onPageSelected } = props;
    const buttons: JSX.Element[] = [];

    for (let page = props.min; page <= props.max; page++) {
        buttons.push(
            <PageButton key={page.toString()}
                current={page === current}
                page={page}
                onClick={onPageSelected} />
        );
    }

    return <>{buttons}</>;
};
